import { noddiAsync, URLKeys } from 'noddi-async';

import { TireType } from '../types';
import { TireMeasurementCard } from './TireMeasurementCard';

interface TireMeasurementTranslations {
  leftFront: string;
  rightFront: string;
  leftBack: string;
  rightBack: string;
  summerTires: string;
  winterTires: string;
  measuredAt: string;
  inAGoodCondition: string;
  missingMeasurements: string;
  soonWornOut: string;
  wornOut: string;
}

interface LatestTireMeasurementsProps {
  carId: number;
  tireType: TireType;
  translations?: TireMeasurementTranslations;
  carName?: string;
  hideCarName?: boolean;
}

export const LatestTireMeasurements = ({
  carId,
  translations,
  tireType,
  carName,
  hideCarName
}: LatestTireMeasurementsProps) => {
  const {
    data: tireMeasurements,
    isPending: isTireMeasurementsPending,
    error: tireMeasurementsError
  } = noddiAsync.useGet({
    type: URLKeys.getLatestCarWheelMeasurements,
    input: { carId }
  });

  if (isTireMeasurementsPending) {
    return <div className='flex h-20 w-full animate-pulse rounded-lg bg-darkPurple40' />;
  }

  if (tireMeasurementsError) {
    return null;
  }

  const measurements = tireMeasurements[tireType];

  if (!measurements || Object.keys(measurements).length === 0) {
    return null;
  }

  return (
    <TireMeasurementCard
      tireType={tireType}
      translations={translations}
      carName={carName}
      measurements={measurements}
      hideCarName={hideCarName}
    />
  );
};
